export default class TriggerFileUpload {
  constructor(options={}) {
    this.selector = options.selector || ".js-trigger-file-upload";
    this.fileField = options.fileField || "[data-js-file]";
    this.bindHandlers();
  }

  bindHandlers() {
    this.openFilePickerOnClick();
    this.submitFormOnFileSelect();
  }

  openFilePickerOnClick() {
    N2.handle("click", this.selector, (evt) => {
      $(this.fileField).click();
    });
  }

  submitFormOnFileSelect() {
    N2.handle("change", this.fileField, (evt) => {
      let $field = $(evt.currentTarget);
      if ($field.val() != null) {
        N2.showProgressIndicator();
        $field.closest("form").submit();
      }
    })
  }
}
